module.exports = __webpack_public_path__ + "img/Symbol_L4.1ea92182.png";